import React, {createContext, useContext, useMemo, ReactNode} from 'react';
import {useAgentDrawer} from '../hooks/useAgentDrawer';

type AgentDrawerContextValue = {
	isOpen: boolean;
	inputValue: string;
	savedPromptTexts: ReadonlySet<string>;
	openDrawer: () => void;
	closeDrawer: () => void;
	setInputValue: (value: string) => void;
	setSavedPromptTexts: (texts: ReadonlySet<string>) => void;
};

const AgentDrawerContext = createContext<AgentDrawerContextValue | null>(null);

type AgentDrawerProviderProps = {
	children: ReactNode;
};

export const AgentDrawerProvider = ({children}: AgentDrawerProviderProps): JSX.Element => {
	const {isOpen, openDrawer, closeDrawer} = useAgentDrawer();
	const [inputValue, setInputValue] = React.useState('');
	const [savedPromptTexts, setSavedPromptTexts] = React.useState<ReadonlySet<string>>(new Set());

	const value = useMemo(
		() => ({isOpen, openDrawer, closeDrawer, inputValue, setInputValue, savedPromptTexts, setSavedPromptTexts}),
		[isOpen, openDrawer, closeDrawer, inputValue, setInputValue, savedPromptTexts, setSavedPromptTexts]
	);

	return <AgentDrawerContext.Provider value={value}>{children}</AgentDrawerContext.Provider>;
};

export const useAgentDrawerContext = (): AgentDrawerContextValue => {
	const ctx = useContext(AgentDrawerContext);
	if (!ctx) throw new Error('useAgentDrawerContext must be used within AgentDrawerProvider');
	return ctx;
};
